import { AudioLevelAnalyser } from '../../helpers/analysers/audio-level-analyser';
import { getAudioContext } from '../../helpers/audio-context';
import { deviceManager } from '../device-manager/instance';
import { BroadcastManager } from './broadcast-manager';

export { goloomSdk } from './instance';
export { deviceManager };

export const broadcastManager = new BroadcastManager();

const audioContext = getAudioContext();
export const audioLevelAnalyser = audioContext ? new AudioLevelAnalyser(audioContext) : null;

export * from './helpers';
export * from './constants';
export * from './types';
